import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card card-lv-warning text-center"
}

import { computed } from "vue";
import { useStore } from "vuex";


export default /*@__PURE__*/_defineComponent({
  __name: 'ContactUs',
  setup(__props) {

const store = useStore();

const visible = computed<boolean>(() => store.state.configuration.workflow?.showContactUsAd ?? false);

function onRequestCallback() {
    window.location.href = "https://www.lv.com/pensions-retirement/pension-drawdown-calculator/request-call-back";
}

return (_ctx: any,_cache: any) => {
  return (visible.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", { class: "card-body" }, [
          _cache[0] || (_cache[0] = _createElementVNode("h5", { class: "fw-bold mt-1 mb-3" }, "Need some help?", -1)),
          _cache[1] || (_cache[1] = _createElementVNode("p", { class: "mb-0" }, [
            _createTextVNode("Call a retirement expert on "),
            _createElementVNode("a", {
              class: "fw-bold",
              href: "tel:08000321925"
            }, "0800 032 1925")
          ], -1)),
          _cache[2] || (_cache[2] = _createElementVNode("p", { class: "mb-0" }, "Mon-Fri 8:30am - 6:00pm. For text phone first dial 18001. Calls may be recorded and/or monitored for training and audit purposes.", -1)),
          _createElementVNode("button", {
            class: "btn btn-secondary mt-2 mb-2 w-auto border fw-bold callback-button no-hover",
            onClick: onRequestCallback
          }, " Request a callback ")
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})